import React from "react";
import { Navigate } from "react-router-dom";
import useDataMainStore from "../stores/dataMainStore";
import MainLayout from "./MainLayout.tsx";

const AuthenticatedLayout = ({ children }) => {
  const { isAuthenticated, token, isTokenExpired } = useDataMainStore();

  if (!isAuthenticated || !token || isTokenExpired()) {
    return <Navigate to="/admin/login" replace />;
  }

  return <MainLayout>{children}</MainLayout>;
};

export default AuthenticatedLayout;
